import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { GlobalLoadingService } from './core/services/global-loading.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  template: `
    <router-outlet></router-outlet>

    <!-- Globaler Loading Overlay -->
    @if (globalLoading.isLoading()) {
      <div class="global-loading-overlay">
        <div class="loading-content">
          <div class="loading-icon">
            <i class="fas fa-cash-register"></i>
          </div>
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Laden...</span>
          </div>
          @if (globalLoading.statusText()) {
            <div class="loading-status">{{ globalLoading.statusText() }}</div>
          }
        </div>
      </div>
    }
  `,
  styles: [`
    .global-loading-overlay {
      position: fixed;
      inset: 0;
      z-index: 9999;
      display: flex;
      justify-content: center;
      align-items: center;
      background: var(--bs-body-bg, #1a1a2e);
      animation: fadeIn 0.2s ease-in;
    }

    @keyframes fadeIn {
      from { opacity: 0; }
      to { opacity: 1; }
    }

    .loading-content {
      text-align: center;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 1.5rem;
    }

    .loading-icon {
      font-size: 3rem;
      color: var(--bs-primary, #0d6efd);
      animation: pulse 2s ease-in-out infinite;
    }

    @keyframes pulse {
      0%, 100% { opacity: 0.6; transform: scale(1); }
      50% { opacity: 1; transform: scale(1.05); }
    }

    .spinner-border {
      width: 2.5rem;
      height: 2.5rem;
    }

    .loading-status {
      color: rgba(255, 255, 255, 0.7);
      font-size: 0.95rem;
      transition: all 0.3s ease;
    }
  `]
})
export class AppComponent {
  private translate = inject(TranslateService);
  protected globalLoading = inject(GlobalLoadingService);

  constructor() {
    this.translate.setDefaultLang('de');
    this.translate.use('de');
  }
}
